import { useCan } from '@/components/can/Can';
import { defaultMeta } from '@/constants/defaultMeta';
import { PERMS } from '@/features/auth/permissions/permissionKeys';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { paymentLogsQueries } from '@/services/payment/payment.queries';
import { useSearch } from '@tanstack/react-router';

export const useGetIndividualStoreLogs = (storeId: string) => {
  const canViewLogs = useCan({ allOf: [PERMS.paymentManagement.storePaymentLogs.details] });
  const { page, fetch, q, sort, createdDate, planTypeFilter, paymentMethodFilter } = useSearch({
    from: '/(app)/payment-management/store-payment-log/$storeId/',
  });

  const parsedDateRange = createdDate
    ? parseDateRangeSearch(Array.isArray(createdDate) ? createdDate.join(',') : createdDate)
    : undefined;

  const { data, isFetched, isLoading } = useQuery({
    ...paymentLogsQueries.details({
      clubId: storeId,
      planTypeFilter: planTypeFilter || undefined,
      paymentMethodFilter: paymentMethodFilter === 'On Arrival' ? 'On site payment' : paymentMethodFilter || undefined,
      row: page ?? 0,
      fetch: fetch ?? 10,
      search: q || undefined,
      fromDateMs: parsedDateRange?.start,
      toDateMs: parsedDateRange?.end,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort, {
        createdDate: 'visitDateTime',
      }),
    }),
    enabled: canViewLogs && !!storeId,
  });

  return {
    individualStoreLogs: data?.data ?? [],
    isFetched,
    isLoading,
    pagination: data?.meta?.pagination ?? defaultMeta,
  };
};
